import { render, staticRenderFns } from "./PrivacyPolicyDE.vue?vue&type=template&id=d5ddcad0&scoped=true"
import script from "./PrivacyPolicyDE.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyDE.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyDE.vue?vue&type=style&index=0&id=d5ddcad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ddcad0",
  null
  
)

export default component.exports